import useStateStore from 'services/store';
import { getProcedures } from 'services/utils';
import './Configurator.scss';

const configs = [
    {
        id: 'fabric',
        text: {
            en: 'Fabric',
        },
        img: 'images/configurator/fabric.svg',
    },
    {
        id: 'inner-fabric',
        text: {
            en: 'Inner fabric',
        },
        img: 'images/configurator/fabric.svg',
    },
    {
        id: 'collar',
        text: {
            en: 'Collar',
        },
        img: 'images/configurator/collar.svg',
    },
    {
        id: 'cuff',
        text: {
            en: 'Cuff/Sleeves',
        },
        img: 'images/configurator/cuff.svg',
    },
    {
        id: 'placket',
        text: {
            en: 'Placket',
        },
        img: 'images/configurator/placket.svg',
    },
    {
        id: 'pocket',
        text: {
            en: 'Pocket',
        },
        img: 'images/configurator/pocket.svg',
    },
    {
        id: 'back-pleats',
        text: {
            en: 'Back pleats',
        },
        img: 'images/configurator/back-vent.svg',
    },
    {
        id: 'monogram',
        text: {
            en: 'Monogram',
        },
        img: 'images/configurator/monogram.jpg',
    },
    {
        id: 'stitch',
        text: {
            en: 'Button Stitch',
        },
        img: 'images/configurator/stitch.svg',
    },
];

const Configurator = () => {
    const { currentConfig, setCurrentConfig, activeProductData, activeFabric } = useStateStore();

    const handleClickOption = (id: string) => {
        setCurrentConfig(id);
        if (currentConfig !== id) {
            const procedures = getProcedures();
            if (procedures?.changeConfigurator) {
                if (id === 'monogram') {
                    const activePlacement =
                        activeProductData[activeFabric].monogram.activePlacement;
                    if (activePlacement && procedures?.changeMonogramPosition) {
                        procedures?.changeMonogramPosition(activePlacement);
                    } else {
                        procedures?.changeConfigurator(id);
                    }
                }
                if (id === 'inner-fabric') {
                    const activePlacement =
                        activeProductData[activeFabric]['inner-fabric'].activePlacement;
                    if (activePlacement && procedures?.changeMonogramPosition) {
                        procedures?.changeInnerPosition(activePlacement);
                    }
                } else {
                    procedures?.changeConfigurator(id);
                }
            }
        }
    };

    return (
        <div className="configurator">
            <div className="configurator-container">
                <div className="config-list">
                    {/* <div className="select-product">Select product</div> */}
                    <div className="list-container">
                        {configs.map((config) => {
                            return (
                                <div
                                    key={config.id}
                                    onClick={() => handleClickOption(config.id)}
                                    className={`config-item-container ${
                                        currentConfig === config.id ? 'active' : ''
                                    }`}
                                >
                                    <div className="img-container">
                                        <img src={config?.img} alt="" />
                                    </div>
                                    <div className="config-text">{config?.text?.en}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Configurator;
